<template>
  <div>
    <Groups
      :groups="groupOpts"
      @loadMoreUser="loadMoreUser"
      @searchUser="searchUser"
      @editGroup="editGroup"
      @deleteGroup="deleteGroup"
      ref="groupsChat"
    ></Groups>
  </div>
</template>
<script>
import Groups from "./Groups.vue";
import { service_names, service_paths } from "@/constants/Services";
import { setTimezone } from "@/pages/ChatRoom/Sidebar/Components/helpers";
import { mapGetters } from "vuex";
import { Message } from "@/helpers/utils";
import { isMessageFromGeneralGroup } from "@/helpers/chat";

export default {
  components: { Groups },
  props: ["tabChange"],
  inject: ["routerToRoomChat"],
  data() {
    return {
      currentId: 1,
      queryGroupId: null,
      isLoading: false,
      groupOpts: [],
      limit: 10,
      currenSearchKey: "",
      cpmKey: null
    };
  },
  created() {
    this.searchUser();
  },
  computed: {
    ...mapGetters("chat", ["socketEvent"])
  },
  watch: {
    socketEvent: function(newVal) {
      this.setSocketEvent(newVal);
    },
    currenSearchKey: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$refs.groupsChat.limit = 10;
      }
    }
  },
  methods: {
    editGroup(user) {
      this.$emit("editGroup", user);
    },
    unSelectRoomChat() {
      this.$refs.groupsChat.currentId = null;
    },
    loadMoreUser(limit) {
      this.searchUser(this.currenSearchKey, limit);
    },
    deleteGroup(groupId) {
      if (!groupId) return;
      return this.$axios
        .delete(`${service_paths.chat}/group/${groupId}`)
        .then(() => {
          this.searchUser(this.currenSearchKey);
          Message.success(this.$t("common.delete_success"));
        });
    },
    getRoomId(event) {
      let roomId = null;
      let firstArg = event.fields?.args[0];
      if (firstArg === "inserted") return;
      roomId = event.fields?.args[1]?.fname;
      return roomId;
    },
    async setSocketEvent(event) {
      //config for room socket , using when can't listen notify-user from socket
      let roomIdFromRoom = this.getRoomId(event);
      //config for notify socket
      let roomIdFromUser = event?.fields?.args[0]?.payload?.rid;
      if (isMessageFromGeneralGroup(event?.fields?.args[1]?._id)) return;
      let roomId = roomIdFromRoom || roomIdFromUser;
      if (!roomId) return;
      let indexChanged = null;
      this.groupOpts.forEach((item, index) => {
        if (item.id === roomId) {
          indexChanged = index;
          item.time = setTimezone(new Date(), true);
          let condition = this.$refs.groupsChat.currentId === roomId;
          if (!roomIdFromRoom) {
            item.unread = condition ? (item.unread = 0) : +item.unread + 1;
          }
        }
      });
      if (indexChanged !== null) {
        this.groupOpts.unshift(this.groupOpts[indexChanged]);
        this.groupOpts.splice(indexChanged + 1, 1);
      } else {
        if (this.isLoading) return;
        this.searchUser(this.currenSearchKey, false);
      }
    },
    searchUser(searchKey, overlayLoading) {
      this.currenSearchKey = searchKey || "";
      this.isLoading = true;
      return this.$axios
        .get(
          service_names.user + "/chat/group",
          { group_name: this.currenSearchKey, count: 100, offset: 0 },
          undefined,
          undefined,
          undefined,
          undefined,
          overlayLoading
        )
        .then(({ data }) => {
          this.groupOpts = [];
          this.groupOpts = data.map(item => {
            return {
              ...item,
              time: setTimezone(item.last_message_at)
            };
          });
          this.isLoading = false;
        });
    },
    refreshGroup(room) {
      this.$refs.groupsChat.getRoomChat(room);
    }
  }
};
</script>
<style lang="scss" scoped></style>
